import React, { ReactNode } from 'react';
import styles from './Tabs.module.scss';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface TabListProps {
  children: ReactNode;
  className?: string;
}

export const TabList = ({ children, className }: TabListProps) => (
  <div className={cx('tab-list', className)}>{children}</div>
);
